import { render, staticRenderFns } from "./LoanStatusAlert.vue?vue&type=template&id=7b60f45e&scoped=true"
import script from "./LoanStatusAlert.vue?vue&type=script&lang=js"
export * from "./LoanStatusAlert.vue?vue&type=script&lang=js"
import style0 from "./LoanStatusAlert.vue?vue&type=style&index=0&id=7b60f45e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b60f45e",
  null
  
)

export default component.exports